namespace Nobox.Nobox {
    export interface CampaignresultRow {
        Id?: number;
        CampaignId?: number;
        Campaign?: string;
        CampaignSource?: CampaignRow;
        ContactId?: number;
        ContactLinkId?: number;
        Contact?: string;
        Group?: string;
        GroupName?: string;
        Subject?: string;
        ShortLink?: number;
        BodyType?: Nobox.BodyType.BodyTypeEnum;
        Body?: string;
        Unik?: string;
        BodyText?: string;
        BodyHtml?: string;
        Status?: number;
        Tags?: string;
        Email?: string;
        InteractiveMsg?: string;
        IsRead?: number;
        IsDirect?: number;
        ReadDate?: string;
        Created?: string;
        Sent?: string;
        Up?: string;
        ProcessBy?: number;
        Note?: string;
        TenantId?: number;
        ChannelId?: number;
        Attachment?: string;
        ProcessDate?: string;
    }

    export namespace CampaignresultRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Subject';
        export const localTextPrefix = 'Nobox.Campaignresult';
        export const lookupKey = 'Nobox.Campaignresult';

        export function getLookup(): Q.Lookup<CampaignresultRow> {
            return Q.getLookup<CampaignresultRow>('Nobox.Campaignresult');
        }
        export const deletePermission = 'Campaign Result:Delete';
        export const insertPermission = 'Campaign Result:Modify';
        export const readPermission = 'Campaign Result:View';
        export const updatePermission = 'Campaign Result:Modify';

        export declare const enum Fields {
            Id = "Id",
            CampaignId = "CampaignId",
            Campaign = "Campaign",
            CampaignSource = "CampaignSource",
            ContactId = "ContactId",
            ContactLinkId = "ContactLinkId",
            Contact = "Contact",
            Group = "Group",
            GroupName = "GroupName",
            Subject = "Subject",
            ShortLink = "ShortLink",
            BodyType = "BodyType",
            Body = "Body",
            Unik = "Unik",
            BodyText = "BodyText",
            BodyHtml = "BodyHtml",
            Status = "Status",
            Tags = "Tags",
            Email = "Email",
            InteractiveMsg = "InteractiveMsg",
            IsRead = "IsRead",
            IsDirect = "IsDirect",
            ReadDate = "ReadDate",
            Created = "Created",
            Sent = "Sent",
            Up = "Up",
            ProcessBy = "ProcessBy",
            Note = "Note",
            TenantId = "TenantId",
            ChannelId = "ChannelId",
            Attachment = "Attachment",
            ProcessDate = "ProcessDate"
        }
    }
}
